module.exports = __webpack_public_path__ + "public/img/bg_tankuang.4df61f58.png";